/**
 * Embedded Angular plugin apps use their own Router and PathLocationStrategy, which only
 * react to `popstate`. The host updates the URL with `history.pushState` / `replaceState`,
 * which does not emit `popstate`, so an already-mounted plugin keeps the previous route.
 *
 * A synthetic `popstate` is not safe here. The host router (`onSameUrlNavigation: 'reload'`)
 * and `ModalService` both treat every `popstate` as the user pressing Back. That reloads the
 * plugin page and closes dialogs, and the resulting `NavigationEnd` notifies again, which
 * loops until the browser throttles history.
 *
 * `phoenix-plugin-url-changed` is a host-only signal. The host router and `ModalService` do
 * not listen for it. `providePhoenixPlugin` follows it and syncs the plugin router with
 * `skipLocationChange` so the plugin does not write history.
 */
export function notifyPluginAppsOfBrowserUrl(): void {
  queueMicrotask(() => {
    window.dispatchEvent(new CustomEvent('phoenix-plugin-url-changed'));
  });
}
